import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehiclesIconSelectorComponent } from './vehicles-icon-selector.component';
import {DxButtonModule, DxDataGridModule, DxDropDownBoxModule, DxLoadPanelModule, DxPopupModule, DxTextBoxModule} from 'devextreme-angular';
import { VehicleIconUploaderComponent } from './vehicle-icon-uploader/vehicle-icon-uploader.component';



@NgModule({
  declarations: [VehiclesIconSelectorComponent, VehicleIconUploaderComponent],
  imports: [
    CommonModule,
    DxPopupModule,
    DxLoadPanelModule,
    DxDataGridModule,
    DxButtonModule,
    DxDropDownBoxModule,
    DxTextBoxModule
  ],
  exports: [VehiclesIconSelectorComponent]
})
export class VehiclesIconSelectorModule { }
